import {Link} from "react-router-dom";
import {Urls} from "component/const/Urls";
import {isEnglish, isJson} from "component/const/Functions";

export const MetaDataTable = ({data}) =>{
    return <>
        <table>
            <thead><tr>
                {data && data.length>0 &&
                    Object.keys(data[0]).map((key, index) => (!isEnglish(key)&&
                        <th key={Urls.concat(['list Table', key, index])} dangerouslySetInnerHTML={{__html: key}}/>
                    ))}
            </tr></thead>
            {data && data.length>0 &&
                <tbody>
                {data.map((item, index) => (<tr key={Urls.concat(['list table body row'+index])}>
                    {Object.keys(item).map((key, i) => (!isEnglish(key)&&
                        <td key={Urls.concat(['list table body item',i,key])}>{
                            !Array.isArray(item[key]) ? item[key]:
                                item[key].map((ite, ind) => (<>
                                        {isJson(ite) ?
                                            <Link style={{fontSize:14}} key={`${i}${key}${ind}`}
                                                  to={JSON.parse(ite).to}
                                                  state={{testId: JSON.parse(ite.replace(/\\/g, '')).test_id,
                                                      appId: JSON.parse(ite.replace(/\\/g, '')).app_id}}>
                                                {JSON.parse(ite.replace(/\\/g, '')).value}</Link>: ite}
                                        {ind < item[key].length - 1 && <br />}
                                    </>)
                                )}</td>
                    ))}</tr>))}
                </tbody>
            }
        </table>
        {(!data || data.length===0) &&
            <div className="column centerElements">
                <p>검색된 데이터가 없습니다.</p>
            </div>
        }
    </>
}
